import React from "react";

const formatMoney = (
  amount,
  currency = "PLN"
) => {
  if (
    amount === null ||
    amount === undefined
  ) {
    return "—";
  }

  return new Intl.NumberFormat(
    "pl-PL",
    {
      style: "currency",
      currency,
    }
  ).format(amount);
};

const getTravellersLabel = (
  count
) => {
  if (count === 1) {
    return "1 podróżny";
  }

  return `${count} podróżnych`;
};

const TfgPreviewListItem = ({
  item,
  isSelected,
  onClick,
}) => {
  const snapshot =
    item.snapshot ?? {};

  return (
    <button
      type="button"
      className={`tfg-preview-list-item ${
        isSelected
          ? "tfg-preview-list-item--selected"
          : ""
      }`}
      onClick={onClick}
      aria-pressed={isSelected}
    >
      <div className="tfg-preview-list-item-top">
        <strong className="tfg-preview-list-item-number">
          {item.contractNumber}
        </strong>

        {item.cancellationDate && (
          <span className="tfg-preview-badge tfg-preview-badge--danger">
            Rozwiązana
          </span>
        )}
      </div>

      <div className="tfg-preview-list-item-summary">
        <span>
          {getTravellersLabel(
            snapshot.travellersCount
          )}
        </span>

        <span aria-hidden="true">
          •
        </span>

        <span>
          {formatMoney(
            snapshot.totalPrice,
            snapshot.currency
          )}
        </span>
      </div>
    </button>
  );
};

export default TfgPreviewListItem;